// Arabic translations for auth
export const arAuthTranslations = {
	auth: {
		welcomeBack: 'مرحبًا بعودتك',
		loginSubtitle: 'تسجيل الدخول لإدارة قائمة مطعمك',
		email: 'البريد الإلكتروني',
		emailPlaceholder: 'your@email.com',
		password: 'كلمة المرور',
		passwordPlaceholder: '••••••••',
		rememberMe: 'تذكرني',
		forgotPassword: 'نسيت كلمة المرور؟',
		login: 'تسجيل الدخول',
		loginWithGoogle: 'تسجيل الدخول باستخدام Google',
		noAccount: 'ليس لديك حساب؟',
		signUp: 'إنشاء حساب',
		invalidCredentials: 'بريد إلكتروني أو كلمة مرور غير صالحة',
		// Registration
		createAccount: 'إنشاء حساب',
		registerSubtitle: 'ابدأ مع قائمة مطعمك',
		name: 'الاسم الكامل',
		namePlaceholder: 'جون دو',
		confirmPassword: 'تأكيد كلمة المرور',
		confirmPasswordPlaceholder: '••••••••',
		agreement: 'أوافق على',
		termsOfService: 'شروط الخدمة',
		privacyPolicy: 'سياسة الخصوصية',
		alreadyHaveAccount: 'لديك حساب بالفعل؟',
		// Password reset
		resetPassword: 'إعادة تعيين كلمة المرور',
		resetPasswordSubtitle: 'أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور',
		sendResetLink: 'إرسال رابط إعادة التعيين',
		backToLogin: 'العودة إلى تسجيل الدخول',
		resetPasswordSuccess: 'تحقق من بريدك الإلكتروني للحصول على تعليمات إعادة التعيين',
		// Validation messages
		required: 'هذا الحقل مطلوب',
		invalidEmail: 'يرجى إدخال بريد إلكتروني صالح',
		passwordLength: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
		passwordsDontMatch: 'كلمات المرور غير متطابقة',
		acceptTerms: 'يجب عليك قبول الشروط والأحكام',
		signin: 'تسجيل الدخول إلى حسابك'
	}
};